import "./vendor/jquery/jquery-3.6.0.min"
import "./components/header-search"
import "./components/data-link"
import "./components/accordion"
import "./components/video"
import "./components/jump-links"
import initTestSearch from "./components/auto-search";
document.addEventListener('DOMContentLoaded', () => {
  initTestSearch();
});
